import axios from 'axios';
import Events from './events';
import EventTypes from './eventTypes';
import FleetSize from './fleetSize';
import Notify from './notify';
import Email from './email';
import User from './user';
import Appointments from './appointments';

const success = (response) => response;
const failure = (error) => Promise.reject(error);

class ApiManager {
  constructor() {
    this.requiresAuth = false;
    // Core api for project
    this.coreObject = axios.create({
      baseURL: process.env.VUE_APP_BASE_API_APP_URL,
    });
    this.events = new Events(this.coreObject);
    this.eventTypes = new EventTypes(this.coreObject);
    this.fleetSize = new FleetSize(this.coreObject);
    this.notify = new Notify(this.coreObject);
    this.email = new Email(this.coreObject);
    this.user = new User(this.coreObject);
    this.appointments = new Appointments(this.coreObject);
    this.coreObject.interceptors.response.use(success, failure);
  }

  /**
   * Add any APIs that require authentication to the array within method.
   */
  setAuthHeader(authToken) {
    [
      // add API needing authentication here
      this.events,
      this.eventTypes,
      this.fleetSize,
      this.notify,
      this.email,
      this.appointments,
    ].forEach((api) => api.setAuthHeader(authToken));
  }
}

export default new ApiManager();
